export const thumbnailGradients = [
    "from-slate-950 via-blue-950 to-zinc-950",
    "from-zinc-950 via-red-950 to-stone-950",
    "from-slate-950 via-indigo-950 to-blue-950",
    "from-zinc-950 via-violet-950 to-slate-950",
    "from-slate-950 via-rose-950 to-pink-950",
    "from-gray-950 via-pink-950 to-fuchsia-950",
    "from-slate-950 via-cyan-950 to-blue-950",
    "from-zinc-950 via-sky-950 to-slate-950",
    "from-stone-950 via-purple-950 to-violet-950",
    "from-slate-950 via-fuchsia-950 to-zinc-950",
    "from-gray-950 via-red-950 to-rose-950",
    "from-zinc-950 via-blue-950 to-indigo-950",
];

export const gradient = thumbnailGradients[6 % thumbnailGradients.length];

/**
 * Deterministic per-id gradient pick: the same id always resolves to the same
 * gradient (stable across re-renders), but doesn't correlate with list order
 * like a plain index would.
 */
export function gradientForId(id: string): string {
    let hash = 0;
    for (let i = 0; i < id.length; i++) {
        hash = (hash * 31 + id.charCodeAt(i)) | 0;
    }
    return thumbnailGradients[Math.abs(hash) % thumbnailGradients.length] ?? "from-slate-950 via-blue-950 to-zinc-950";
}
